module.exports = __webpack_public_path__ + "static/media/PastorArias.eacb725e.jpg";